// extracted by mini-css-extract-plugin
module.exports = {"link":"BaseLink_link_2J8gY"};